import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { MenuItem } from './MenuItem';
import { DropdownMenuItem } from './DropdownMenuItem';
import './NavMenu.css';
import { AppSelectMenu } from './AppSelectMenu';
import { UserMenu } from './UserMenu';
import { ProviderSelectMenu } from './ProviderSelectMenu';
import { storage, TOKEN_INFO } from '../../app/Storage';
import { decode } from 'jsonwebtoken';

export class NavMenu extends Component {
    static contextTypes = {
        selectedApp: PropTypes.object,
        selectedProvider: PropTypes.string,
        setSelectedMenuItem: PropTypes.func,
        selectedMenuItem: PropTypes.string,
        setSelectedMenuItemTitle: PropTypes.func,
        selectedMenuItemTitle: PropTypes.string,
        setShowMetadataButton: PropTypes.func
    }

    displayName = NavMenu.name;

    constructor(props) {
        const dropdowns = {
            "network": {
                icon: "icon-network",
                label: "Rede",
                items: [
                    { icon: "icon-lines", label: "Linhas", to: "/datamanager/lines", showMetadata: true },
                    { icon: "icon-paths", label: "Percursos", to: "/datamanager/paths", showMetadata: false },
                    { icon: "icon-map-points", label: "Pontos Notáveis", to: "/datamanager/mapPoints", showMetadata: true },
                    { icon: "icon-stops", label: "Paragens", to: "/datamanager/stops", showMetadata: true },
                    { icon: "icon-path-stops", label: "Paragens por Percurso", to: "/datamanager/pathStops", showMetadata: true },
                ]
            },
            "countyTransportAuthority": {
                icon: "icon-county",
                label: "Município",
                items: [
                    { icon: "icon-zones", label: "Pontos de Interesse", to: "/datamanager/pointsOfInterest", showMetadata: false },
                    { icon: "icon-bicycle", label: "Ciclovias", to: "/datamanager/lanes", showMetadata: false }
                ]
            },
            "networkTransportAuthority": {
                icon: "icon-network",
                label: "Rede",
                items: [
                    { icon: "icon-map-points", label: "Pontos Notáveis", to: "/datamanager/mapPoints", showMetadata: true }
                ]
            },
            "schedules": {
                icon: "icon-trips",
                label: "Viagens",
                items: [
                    { icon: "icon-schedules", label: "Horários", to: "/datamanager/schedules", showMetadata: true },
                    { icon: "icon-day-types", label: "Tipos de Dia", to: "/datamanager/dayTypes", showMetadata: true },
                    { icon: "icon-set-of-day-types", label: "Conjuntos de Tipos de Dia", to: "/datamanager/setOfDayTypes", showMetadata: true },
                    { icon: "icon-passing-times", label: "Tempos de Passagem", to: "/datamanager/passingTimes", showMetadata: true },
                    { icon: "icon-calendars", label: "Calendário", to: "/datamanager/calendar", showMetadata: true }
                ]
            },
            "fares": {
                icon: "icon-fares",
                label: "Tarifários",
                items: [
                    { icon: "icon-currency", label: "Moedas", to: "/datamanager/currencies", showMetadata: false },
                    { icon: "icon-fare-product", label: "Produtos", to: "/datamanager/fareProducts", showMetadata: false },
                ]
            },
            "faresTransportAuthority": {
                icon: "icon-fares",
                label: "Tarifários",
                items: [
                    { icon: "icon-currency", label: "Moedas", to: "/datamanager/currencies", showMetadata: false },
                    { icon: "icon-fare-product", label: "Produtos", to: "/datamanager/fareProducts", showMetadata: false },
                ]
            },
            "configs": {
                icon: "icon-definitions",
                label: "Configuração",
                items: [
                    { icon: "icon-editions", label: "Edições", to: "/datamanager/editions", showMetadata: false },
                    { icon: "icon-plus", label: "Importação de Dados", to: "/datamanager/import", showMetadata: false },
                    { icon: "icon-download", label: "Exportação de Dados", to: "/datamanager/export", showMetadata: true },
                    { icon: "icon-colors", label: "Cores", to: "/datamanager/lineColors", showMetadata: true },
                    { icon: "icon-vertical", label: "Gestão de interfaces", to: "/datamanager/interfaces", showMetadata: false },
                    { icon: "icon-messages", label: "Mensagens", to: "/datamanager/messages", showMetadata: false },
                    { icon: "icon-lines", label: "Ver Documentos Gerados", to: "/datamanager/documents", showMetadata: false },
                ]
            },
            "configsTransportAuthority": {
                icon: "icon-definitions",
                label: "Configuração",
                items: [
                    { icon: "icon-editions", label: "Edições", to: "/datamanager/editions", showMetadata: false },
                    { icon: "icon-plus", label: "Importação de Dados", to: "/datamanager/import", showMetadata: false },
                    { icon: "icon-vertical", label: "Gestão de interfaces", to: "/datamanager/interfaces", showMetadata: false },
                ]
            }
        };

        const menuItems = {
            "datamanager": {
                items: [
                    { label: "Dashboard", to: "/datamanager", showMetadata: false }
                ]
            },
            "bussched": {
                items: [
                    { label: "Gerar Horário", label: "Gerar Horário", to: "/bussched", showMetadata: true },
                    { label: "Listar Horários Gerados", label: "Listar Horários Gerados", to: "/bussched/schedules/list", showMetadata: true },
                    { label: "Configuração de Layouts", label: "Configuração de Layouts", to: "/bussched/layoutConfigurations", showMetadata: true },
                    { label: "Tipos de Letra", label: "Tipos de Letra", to: "/bussched/fontsResources", showMetadata: true },
                ]
            },
            "bussmap": {
                items: [
                    { label: "Criar Novo Mapa", to: "/busmap", showMetadata: false },
                    { label: "Ver BusMaps existentes", to: "/busmap/list", showMetadata: false },
                    { label: "Definições", to: "/busmap/settings", showMetadata: false },
                ]
            },
            "spidersmap": {
                items: [
                    { label: "Gerar Spider Maps", to: "/spidermap", showMetadata: false },
                    { label: "Listar Spider Maps Gerados", to: "/spidermap/list", showMetadata: false },
                    { label: "Configurar Spider Maps", to: "/spidermap/settings", showMetadata: false },
                ]
            }
        };

        let dropdownActive = undefined;
        for (var key in dropdowns) {
            if (dropdowns[key].items.some(function (item) { return (window.location.pathname === item.to) })) {
                dropdownActive = key;
                break;
            }
        }

        super(props);
        this.state = {
            dropdownActive: dropdownActive,
            dropdowns: dropdowns,
            menuItems: menuItems,
            selectedMenuItem: '',
            selectedMenuItemTitle: '',
        };
    }

    componentDidMount() {
        const currentPath = window.location.pathname;
        const menuItem = this.findMenuItemByPath(currentPath);
        const { setSelectedMenuItem, setSelectedMenuItemTitle, setShowMetadataButton } = this.context;
        if (menuItem) {
            setSelectedMenuItem(currentPath);
            setSelectedMenuItemTitle(menuItem.label);
            setShowMetadataButton(menuItem.showMetadata);
        }
    }

    findMenuItemByPath(path) {
        const { dropdowns, menuItems } = this.state;

        // Check dropdowns
        for (const dropdownKey in dropdowns) {
            const dropdown = dropdowns[dropdownKey];
            for (const item of dropdown.items) {
                if (item.to === path) {
                    return item;
                }
            }
        }

        // Check menuItems
        for (const menuItemKey in menuItems) {
            const menuItem = menuItems[menuItemKey];
            for (const item of menuItem.items) {
                if (item.to === path) {
                    return item;
                }
            }
        }

        return null;
    }


    dropdownClickHandler(dropdown) {
        const { dropdownActive } = this.state;

        if (dropdownActive === dropdown) {
            this.setState({
                dropdownActive: undefined
            });
        }
        else {
            this.setState({
                dropdownActive: dropdown
            });
        }
    }

    render() {
        const { dropdowns, dropdownActive} = this.state;
        const { isMenuOpen } = this.props;
        const transportAuthorityPage = undefined !== this.context.selectedProvider && this.context.selectedProvider.startsWith("0:");

        let customBusSchedGenerator = false;
        let tokenInfo = storage.get(TOKEN_INFO);

        if (typeof tokenInfo !== 'undefined') {
            var json = JSON.parse(tokenInfo);
            tokenInfo = Object.assign({}, json);
        }

        if (tokenInfo.id_token) {
            let idToken = decode(tokenInfo.id_token);

            customBusSchedGenerator = idToken.cbsg === "True";
        }

        return (
            <nav className={isMenuOpen ? "icon-nav-open" : "icon-nav"}>
                <div className="icon-nav-item">
                    <div className="menu-toggle">
                        <a onClick={this.props.toggleMenuHandler}>
                            <div className={"icon-menu"}></div>
                        </a>
                    </div>

                    <ProviderSelectMenu />
                    <div className="clearfix" />

                    <AppSelectMenu />

                    {this.context.selectedApp.path === 'datamanager' && !transportAuthorityPage ?
                        [
                            <MenuItem 
                                key="menu-datamanager-dashboard" 
                                label="Dashboard" 
                                icon="icon-dashboard" 
                                to="/datamanager" 
                                showMetadata={false} exact 
                                app={this.context.selectedApp.path} />,

                            <DropdownMenuItem key="dropdown-network"
                                data={dropdowns["network"]}
                                app={this.context.selectedApp.path}
                                dropdownId="network"
                                showItems={dropdownActive === "network"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                            <DropdownMenuItem key="dropdown-schedules"
                                data={dropdowns["schedules"]}
                                app={this.context.selectedApp.path}
                                dropdownId="schedules"
                                showItems={dropdownActive === "schedules"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                            <DropdownMenuItem key="dropdown-fares"
                                data={dropdowns["fares"]}
                                app={this.context.selectedApp.path}
                                dropdownId="fares"
                                showItems={dropdownActive === "fares"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                            <DropdownMenuItem key="dropdown-configs"
                                data={dropdowns["configs"]}
                                app={this.context.selectedApp.path}
                                dropdownId="configs"
                                showItems={dropdownActive === "configs"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                        ] : null}
                    {this.context.selectedApp.path === 'datamanager' && transportAuthorityPage ?
                        [
                            <MenuItem 
                                key="menu-datamanager-dashboard" 
                                label="Dashboard" 
                                icon="icon-dashboard" 
                                to="/datamanager" 
                                showMetadata={false} exact 
                                app={this.context.selectedApp.path}  />,

                            <DropdownMenuItem key="dropdown-county"
                                data={dropdowns["countyTransportAuthority"]}
                                app={this.context.selectedApp.path}
                                dropdownId="county"
                                showItems={dropdownActive === "county"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                            <DropdownMenuItem key="dropdown-network"
                                data={dropdowns["networkTransportAuthority"]}
                                app={this.context.selectedApp.path}
                                dropdownId="network"
                                showItems={dropdownActive === "network"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                            <DropdownMenuItem key="dropdown-fares"
                                data={dropdowns["faresTransportAuthority"]}
                                app={this.context.selectedApp.path}
                                dropdownId="fares"
                                showItems={dropdownActive === "fares"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                            <DropdownMenuItem key="dropdown-configs"
                                data={dropdowns["configsTransportAuthority"]}
                                app={this.context.selectedApp.path}
                                dropdownId="configs"
                                showItems={dropdownActive === "configs"}
                                onClickHandler={(a) => {
                                    this.dropdownClickHandler(a)
                                    this.props.toggleDropdownExtendedHandler()
                                }
                                } />,

                        ] : null}
                    {this.context.selectedApp.path === 'bussched' && !customBusSchedGenerator ?
                        [
                            <MenuItem key="menu-schedules-generate" label="Gerar Horário" icon="icon-manage-uptime" to="/bussched" showMetadata={true}  exact app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-schedules-list" label="Listar Horários Gerados" icon="icon-lines" to="/bussched/schedules/list" showMetadata={true}  app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-layout-configurations" label="Configuração de Layouts" icon="icon-config-layouts" to="/bussched/layoutConfigurations" showMetadata={true}  app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-fonts-resources" label="Tipos de Letra" icon="icon-font-type" to={"/bussched/fontsResources"} showMetadata={true}  app={this.context.selectedApp.path} />
                        ] : null}
                    {this.context.selectedApp.path === 'bussched' && customBusSchedGenerator ?
                        [
                            <MenuItem key="menu-schedules-generate" label="Gerar Horário" icon="icon-manage-uptime" to="/bussched" showMetadata={true}  exact app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-schedules-list" label="Listar Horários Gerados" icon="icon-lines" to="/bussched/schedules/list" showMetadata={true}  app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-schedules-updates" label="Últimas Atualizações de Dados" icon="icon-trips" to="/bussched/updates" showMetadata={true}  app={this.context.selectedApp.path} />
                        ] : null}
                    {this.context.selectedApp.path === 'busmap' ?
                        [
                            <MenuItem key="menu-new" label="Criar Novo Mapa" icon="icon-plus" to="/busmap" showMetadata={false}  exact app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-list" label="Ver BusMaps existentes" icon="icon-lines" to="/busmap/list" showMetadata={false}  app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-settings" label="Definições" icon="icon-definitions" to="/busmap/settings" showMetadata={false}  app={this.context.selectedApp.path} />
                        ] : null}
                    {this.context.selectedApp.path === 'spidermap' ?
                        [
                            <MenuItem key="menu-spidermap-generate" label="Gerar Spider Maps" icon="icon-manage-uptime" showMetadata={false}  to="/spidermap" exact app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-spidermap-list" label="Listar Spider Maps Gerados" icon="icon-lines" showMetadata={false}  to="/spidermap/list" app={this.context.selectedApp.path} />,
                            <MenuItem key="menu-spidermap-settings" label="Configurar Spider Maps" icon="icon-definitions" showMetadata={false} to="/spidermap/settings" app={this.context.selectedApp.path} />
                        ] : null
                    }

                    <div className="icon-nav-item-logout">
                        <div className="icon-nav-item-logout-icon">
                            <UserMenu app={this.context.selectedApp.path} />
                        </div>
                    </div>
                </div>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/nav/NavMenu.js